import React, { useState } from "react"

import { connect, useSelector } from "react-redux"

import "./index.scss"

import { TabContext, TabPanel } from "@mui/lab"
import { Box } from "@mui/material"
import OutsideClickHandler from "react-outside-click-handler"

import {
  setReplyMessage,
  setModalPeopleNudge,
  hideSuggestionListFooter,
} from "@actions/commonActions"
import {
  setSuggestionRemovedStatus,
  removeSuggestionRemovedStatus,
} from "@actions/teeupActions"
import Header from "@components/ui/DefaultModal/Header"
import { Tab, TabList } from "@components/ui/Tabs"
import {
  selectMessageById,
  selectActiveTeeupId,
  selectActiveTeeupGameplans,
} from "@selectors/activeTeeup"
import { selectTeeupGameplans, selectTeeupPeople } from "@selectors/teeups"
import { locationTypeIds } from "@utils/gamePlanUtils"
import getWhenSuggestionDetails from "@utils/gameplan/getWhenSuggestionDetails"
import { UNKNOWN_TIMEZONE } from "@utils/peopleUtils"
import { useTeeupPeopleStore } from "stores/teeupPeopleStore"

import { store } from "../../../index"

import { CONTENT_TYPES } from "./constants"
import { PopupActions } from "./molecules"
import MeetingDetails from "./molecules/MeetingDetails"
import OtherSuggestions from "./molecules/OtherSuggestions"
import Reactions from "./molecules/Reactions"
import ReactToggle from "./molecules/ReactToggle"
import Replies from "./molecules/Replies"
import SuggestionItem from "./molecules/SuggestionItem"
import Timezones from "./molecules/Timezones"
import {
  PopupContentWrapper,
  SuggestionContentWrapper,
  SuggestionWrapper,
} from "./newSuggestionPopupStyles"

const SuggestionPopup = ({
  currentSuggestion,
  toggleSuggestionPopup,
  setCurrentSuggestion,
  currentSuggestionData,
  // people,
  // renderLines,
  // renderRightHeaderPart,
  // setModalPeopleNudge,
  // setReplyMessage,
  // setSuggestionRemovedStatus,
  // removeSuggestionRemovedStatus,
  // onAddSuggestion,
  handleOpenSuggestion,
  // hideSuggestionListFooter,
  // draggableSuggestionRow,
  // initialSuggestions,
}) => {
  const [popupContentType, setPopupContentType] = useState(
    CONTENT_TYPES.DEFAULT
  )
  const isWhenSuggestion = currentSuggestionData.type === "when"

  // Time Zone Summary popup, second entry point (restores the original mobile 2018-2019
  // design's When-suggestion affordance -- see TeeupPeople/TitleContent for the primary
  // People-card chip entry point; both open the SAME modal instance/store flag, mounted once
  // in TeeupPeople so it doesn't need its own copy of the participant list here). Gated the
  // same way as the People-card chip: 2+ distinct KNOWN participant timezones.
  const teeupPeople = Object.values(useSelector(selectTeeupPeople) || {})
  const isMultiTimezone =
    new Set(
      teeupPeople
        .map(person => person?.timezone)
        .filter(tz => tz && tz !== UNKNOWN_TIMEZONE)
    ).size >= 2
  const setIsTimeZoneSummaryModalOpen = useTeeupPeopleStore(
    state => state.setIsTimeZoneSummaryModalOpen
  )
  const openTimeZoneSummary = () => setIsTimeZoneSummaryModalOpen(true)
  const defaultTabLabel = isWhenSuggestion ? "Date details" : "Meeting details"
  const currentGamePlan = useSelector(selectActiveTeeupGameplans).find(
    gamePlan => gamePlan.type === currentSuggestionData.type
  )
  const meetingDetails = isWhenSuggestion
    ? getWhenSuggestionDetails(currentSuggestionData)
    : getWhenSuggestionDetails(currentSuggestionData)
  console.log("meetingDetails", meetingDetails)
  const isGeneralSuggestion =
    (!meetingDetails?.empty && isWhenSuggestion) ||
    currentSuggestion.isCustomDate
  const isTimeWheelSuggestion =
    meetingDetails?.empty && isWhenSuggestion && !currentSuggestion.isCustomDate

  const closeSuggestionPopup = () => {
    toggleSuggestionPopup(false)
    setCurrentSuggestion && setCurrentSuggestion({})
  }

  const isMap =
    currentSuggestion.type === "where" &&
    currentSuggestion?.locationType === locationTypeIds.realWorld

  // QJ refinement (2026-07-04, revises the earlier total no-votes ban): thumbs are the weigh-in
  // affordance WHILE a suggestion is undecided (any participant reacts, no organizer gate, no
  // numeric tally -- see ReactToggle's own comment). Once decided the affordance is irrelevant --
  // hide it entirely rather than leaving a stale toggle on a locked-in choice.
  const isSuggestionDecided = !!(
    currentSuggestion?.isDecided || currentSuggestion?.decided
  )

  return (
    <div
      className="suggestion__popup--wrapper"
      onClick={e => e.stopPropagation()}>
      <OutsideClickHandler onOutsideClick={closeSuggestionPopup}>
        <PopupContentWrapper>
          <Header
            title="Suggestion details"
            onBackClick={closeSuggestionPopup}
          />

          <SuggestionContentWrapper
            $isDefault={popupContentType === CONTENT_TYPES.DEFAULT}>
            <SuggestionWrapper>
              <SuggestionItem
                suggestion={currentSuggestion}
                title={meetingDetails.title}
                subtitle={meetingDetails.subtitle}
              />
              {!isSuggestionDecided && (
                <ReactToggle suggestionId={currentSuggestion.id} />
              )}
            </SuggestionWrapper>

            <PopupActions
              currentSuggestion={currentSuggestion}
              toggleSuggestionPopup={toggleSuggestionPopup}
              setCurrentSuggestion={setCurrentSuggestion}
              handleOpenSuggestion={handleOpenSuggestion}
              setPopupContentType={setPopupContentType}
              isGeneralSuggestion={isGeneralSuggestion}
            />
          </SuggestionContentWrapper>

          <TabContext value={popupContentType}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={(e, newValue) => setPopupContentType(newValue)}>
                <Tab label={defaultTabLabel} value={CONTENT_TYPES.DEFAULT} />
                {isTimeWheelSuggestion && (
                  <Tab label="Timezones" value={CONTENT_TYPES.TIMEZONES} />
                )}
                <Tab label="Replies" value={CONTENT_TYPES.REPLIES} />
                <Tab label="Reactions" value={CONTENT_TYPES.REACTIONS} />
                <Tab
                  label="Other suggestions"
                  value={CONTENT_TYPES.SUGGESTIONS}
                />
              </TabList>
            </Box>

            <TabPanel value={CONTENT_TYPES.DEFAULT}>
              <MeetingDetails
                suggestion={currentSuggestion}
                title={meetingDetails.title}
                subtitle={meetingDetails.subtitle}
                isMap={isMap}
                isWhenSuggestion={isWhenSuggestion}
              />
              {/* Second Time Zone Summary entry point (mobile 2018-2019 parity): the When-
                  suggestion's own Date-details tab. Additive-only -- no MeetingDetails/
                  NewTeeupGameplan internals touched. */}
              {isWhenSuggestion && isMultiTimezone && (
                <div
                  className="suggestion-popup__timezone-summary-link"
                  data-testid="suggestion-popup-timezone-summary"
                  onClick={openTimeZoneSummary}>
                  Time Zone Summary
                </div>
              )}
            </TabPanel>
            {isTimeWheelSuggestion && (
              <TabPanel value={CONTENT_TYPES.TIMEZONES}>
                <Timezones />
              </TabPanel>
            )}
            <TabPanel value={CONTENT_TYPES.REACTIONS}>
              <Reactions suggestion={currentSuggestion} />
            </TabPanel>
            <TabPanel value={CONTENT_TYPES.REPLIES}>
              <Replies />
            </TabPanel>
            <TabPanel value={CONTENT_TYPES.SUGGESTIONS}>
              <OtherSuggestions suggestions={currentGamePlan?.suggestions} />
            </TabPanel>
          </TabContext>
        </PopupContentWrapper>
      </OutsideClickHandler>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    initialSuggestions: state.activeTeeup.messages.find(
      message => message.suggestionIds
    )?.gameplans,
    gameplans: selectTeeupGameplans(state),
    activeTeeupId: selectActiveTeeupId(state),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setModalPeopleNudge: (value, id, typeId) =>
      dispatch(setModalPeopleNudge(value, id, typeId)),
    setReplyMessage: message => dispatch(setReplyMessage(message)),
    setSuggestionRemovedStatus: (id, activeTeeupId) =>
      dispatch(setSuggestionRemovedStatus(id, activeTeeupId)),
    removeSuggestionRemovedStatus: (id, activeTeeupId) =>
      dispatch(removeSuggestionRemovedStatus(id, activeTeeupId)),
    hideSuggestionListFooter: () => dispatch(hideSuggestionListFooter()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SuggestionPopup)
